<script>
import dayjs from '@/services/date'
export default {
  name: 'CandidateAvailabilityChart',
  props: {
    availabilityObject: {
      type: Object,
      default: () => {
        return {
          numberOfDays: 7,
          dateStart: '2022-08-22',
          permAvail: [true, true, true, true, true, false, false],
          bookings: [[123123123, 1231231234], [], [], [], [], [], []],
          tempAvailability: [1, 0, 1, 0, 0, 0, 2],
        }
      },
    },
  },
  methods: {
    returnDate: function(dt, offset) {
      var d = dayjs(dt)
      var nd = d.add(offset, 'day')
      return nd.format('D')
    },
  },
}
</script>

<template>
  <div class="candidateAvailabilityChartWrapper">
    <div class="candidateAvailabilityChart">
      <div
        v-for="(x, index) in availabilityObject.tempAvailability"
        :key="index"
      >
        <div>{{ returnDate(dateStart, index) }}</div>
        <div v-if="availabilityObject.permAvail[index]" class="line green">
        </div>
        <div v-else class="line red"></div>
      </div> </div
  ></div>
</template>

<style lang="scss" scoped>
.candidateAvailabilityChartWrapper {
  display: inline-block;
}
.candidateAvailabilityChart {
  border-radius: 5px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
  padding: 0px;
  display: flex;
  overflow: hidden;
  div {
    font-size: 12px;
    width: 1.5em;
    text-align: center;
    div {
    }
    div.line {
      height: 5px;
    }
    div.green {
      background-color: green;
    }
    div.red {
      background-color: red;
    }
  }
}
</style>
